<template>
    
  <div id="date-picker" v-cloak v-click-outside="closeInput">
    <div class="date-wrapper">
      <vs-input type="text" class="inputx" v-model="dateformat" @input="updatePickedDate($event)" @click="onClickInput()" @blur.prevent="onBlur()"/>
      <!-- <vs-input type="text" class="inputx" v-model.lazy="dateformat" @click="onClickInput()" @blur.prevent="onBlur()"/> -->
      <img src="../../assets/img/icon_date.svg" alt="schedule">
      <Tooltip
        :text="$t('dash.datepicker.error-format')"
        position="top"
        v-if="errorFormat"
      >  
        <i class="material-icons">error</i>   
        &nbsp; 
      </Tooltip> 
      
    </div>
    <div :style="top && 'bottom: 50px'" class="calendar" v-show="open || eventOpen" @mouseDown.prevent.stop="onMouseDown()" @mouseUp.prevent.stop="onMouseUp()">
      <div class="date-header">
        <div class="center">
          <div class="left arrow" @click="changeCurMonth(-1)">
<i class="material-icons">keyboard_arrow_left</i>          </div>
          <div class="right arrow" @click="changeCurMonth(1)">
<i class="material-icons">keyboard_arrow_right</i>          </div>
          <div class="month">{{ `${formatMonth(curMonth)} ${curYear}` }}</div>
        </div>
      </div>
      <table>
        <tbody>
          <tr v-for="(row, key) in rows" :key="key">
            <td class="day" v-for="(date, key) in row" :key="key" @click="pickDate(date)" :class="{ 'other-month': date.getMonth() !== curMonth , 'selected': date.valueOf() == pickedDate.valueOf(), 'disable' : dateIsDisabled(date) }">
              {{ date.getDate() }}
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>

</template>

<script>
import moment from 'moment'
import ClickOutside from 'vue-click-outside'
import Tooltip from './tooltip/tooltipInit.vue'

export default {
  name: 'component-datepicker',

  props: {
    gridData: Array,
    date : Date,
    from: Date,
    to: Date,
    noLimit: Boolean,
    now: Boolean,
    eventOpen: Boolean,
    top: Boolean
  },

  components: {
    Tooltip
  },

  directives: {
    ClickOutside
  },

  data() {
    let d = this.date
    return {
      open: false,
      forceOpen: false,
      pickedDate: d,
      curYear: d.getFullYear(),
      curMonth: d.getMonth(),
      curDay: d.getDate(),
      dateformat: null,
      errorFormat: false
    }
  },

  created: function () {
    let d = this.pickedDate
    this.dateformat = (d.getDate() < 10 ? '0' + d.getDate() : d.getDate()) + "/" + (d.getMonth() < 9 ? '0' + (d.getMonth() + 1) : d.getMonth() + 1) + "/" + d.getFullYear()
  },

  watch: {
    date: function(){
      this.pickedDate = this.date
      this.curYear = this.date.getFullYear()
      this.curMonth = this.date.getMonth()
      this.curDay = this.date.getDate()
      let d = this.pickedDate
      this.dateformat = (d.getDate() < 10 ? '0' + d.getDate() : d.getDate()) + "/" + (d.getMonth() < 9 ? '0' + (d.getMonth() + 1) : d.getMonth() + 1) + "/" + d.getFullYear()
    }
  },

  computed: {
    showDate: {
      get() {
        let d = this.pickedDate
        return (d.getDate() < 10 ? '0' + d.getDate() : d.getDate()) + "/" + (d.getMonth() < 9 ? '0' + (d.getMonth() + 1) : d.getMonth()) + "/" + d.getFullYear()
      }
    },
    
    leapYear() {
      if (this.curYear % 100 === 0) {
        return this.curYear % 400 === 0
      } else {
        return this.curYear % 4 === 0
      }
    },
    dates() {
      let ret = []
      let firstDayOfMonth = new Date(this.curYear, this.curMonth, 1)
      let lastDayOfMonth = new Date(this.curYear, this.curMonth, this.getLastDayOfMonth(this.curMonth))
      ret.unshift(firstDayOfMonth)
      for (let d = this.prevDate(firstDayOfMonth); d.getDay() !== 0; d = this.prevDate(d)) {
        ret.unshift(d)
      }
      for (let d = this.nextDate(firstDayOfMonth); d <= lastDayOfMonth; d = this.nextDate(d)) {
        ret.push(d)
      }
      for (let d = this.nextDate(lastDayOfMonth); d.getDay() !== 6; d = this.nextDate(d)) {
        ret.push(d)
      }
      return ret
    },
    rows() {
      return this.dates.reduce(function(p, c, i) {
        if (i % 7 === 0) {
          p[p.length] = []
        }
        p[p.length - 1].push(c)
        return p
      }, [])
    }
  },

  methods: {

    onClickInput() {
      this.open = !this.open;
    },

    closeInput() {
      this.open = false;
    },

    dateIsDisabled(date) {
      if(this.noLimit)
        return false
      if(this.now)
        return moment(date).hour(23).minutes(59).toDate() < moment().toDate()
      if (!this.from && !this.to) {
        return date < new Date().setDate(new Date().getDate()-1) || date.getTime() > new Date().setDate(new Date().getDate()+75)
      }
      return date > this.to || moment(date).add(12, 'hour').toDate() < this.from;
    },

    changeCurMonth(n) {
      let temp = this.curMonth + n
      if (temp < 0) {
        this.curYear -= 1
      } else if (temp >= 12) {
        this.curYear += 1
      }
      this.curMonth = ((temp) + 12) % 12
    },
    nextDate(d) {
      let ret = new Date(d.valueOf())
      ret.setDate(d.getDate() + 1)
      return ret
    },
    prevDate(d) {
      let ret = new Date(d.valueOf())
      ret.setDate(d.getDate() - 1)
      return ret
    },
    getLastDayOfMonth(m) {
      let ret = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31]
      if (this.leapYear) {
        ret[1] = 29
      }
      return ret[m]
    },
    pickDate(d) {
      if(this.dateIsDisabled(d)) return
      this.pickedDate = d
      this.curMonth = d.getMonth()
      this.curYear = d.getFullYear()
      this.formatDate()
      this.open = false

      this.$emit('picked', this.pickedDate)
    },
    formatDate() {
      let d = this.pickedDate
      this.dateformat = (d.getDate() < 10 ? '0' + d.getDate() : d.getDate()) + "/" + (d.getMonth() < 9 ? '0' + (d.getMonth() + 1) : d.getMonth() + 1) + "/" + d.getFullYear()
    },
    onFocus () {
      this.open = true
    },
    onBlur () {
    },
    onMouseDown () {
    },
    onMouseUp () {
    },
    updatePickedDate(v) {
      let reg = new RegExp('(\\d{2})/(\\d{2})/(\\d{4})')
      let m = reg.exec(v)
      if (m) {
        let month = parseInt(m[2])
        let day = parseInt(m[1])
        if (month > 12 || month < 1) {
          this.errorFormat = true
          this.$emit('errorFormat', true)
          return
        }
        if (day < 1 || day > this.getLastDayOfMonth(month)) {
          this.errorFormat = true
          this.$emit('errorFormat', true)
          return
        }
        this.errorFormat = false
        this.$emit('errorFormat', false)
        this.pickedDate = new Date(m[3], parseInt(m[2]) - 1, m[1])
        this.curMonth = parseInt(m[2]) - 1
        this.curYear = parseInt(m[3])

        this.$emit('picked', this.pickedDate)
      }
      else {
        this.errorFormat = true
        this.$emit('errorFormat', true)
      }
      
      // let reg = new RegExp('(\\d{4})-(\\d{2})-(\\d{2})')
      // let m = reg.exec(v)
      // if (m) {
      //   let month = parseInt(m[2])
      //   let day = parseInt(m[3])
      //   if (month > 12 || month < 1) {
      //     return
      //   }
      //   if (day < 1 || day > this.getLastDayOfMonth(month)) {
      //     return
      //   }
      //   this.pickedDate = new Date(m[1], parseInt(m[2]) - 1, m[3])
      //   this.curMonth = parseInt(m[2]) - 1
      //   this.curYear = parseInt(m[1])

      //   this.$emit('picked', this.pickedDate)
      // }
    },
    formatMonth(month){
      return [
        this.$t('dash.datepicker.jan'),
        this.$t('dash.datepicker.feb'),
        this.$t('dash.datepicker.mar'),
        this.$t('dash.datepicker.apr'),
        this.$t('dash.datepicker.may'),
        this.$t('dash.datepicker.jun'),
        this.$t('dash.datepicker.jui'),
        this.$t('dash.datepicker.aug'),
        this.$t('dash.datepicker.sep'),
        this.$t('dash.datepicker.oct'),
        this.$t('dash.datepicker.nov'),
        this.$t('dash.datepicker.dec')
      ][month]
    }
  }
}    
</script>